import React from 'react';

import { PreviewHeader } from 'src/components/atoms/PreviewHeader';
import { ContentPageProps } from '../../../types/PageProps';
import { SerializedUISection } from '../../../types/Section';
import { HiddenPageTitle } from '../../atoms/HiddenPageTitle';
import { Seo } from '../../atoms/Seo';
import { Sections } from '../../molecules/Sections';
import * as styles from './RibbonsPage.styles';

const blockHasPageTitle = (blocks: SerializedUISection[]) =>
  blocks.some((block) => block.props.headingIsPageTitle);

export const RibbonsPage = ({
  pageMetadata: { isPreview },
  pageContent: { title, seo, sections },
}: ContentPageProps) => {
  const renderHiddenPageTitle = !blockHasPageTitle(sections);

  return (
    <div css={styles.container}>
      <Seo {...seo} />
      {renderHiddenPageTitle && <HiddenPageTitle>{title}</HiddenPageTitle>}
      {isPreview && <PreviewHeader />}
      {sections ? <Sections sections={sections} isPreview={isPreview} /> : null}
    </div>
  );
};
